export default "__VITE_ASSET__BudKj5xz__"